import Footer from '../../Components/Footer';
import StoriesBrowser from '../../Components/Main pages/Story';
import Navbar from '../../Components/Navbar';
import styles from './StoriesPage.module.css'
import Landingpage from '../Home/Landingpage';
import Button from '../../Components/Button';
import SearchSidebar from '../../Components/Search bars/Treesearch';
// import SearchSidebar from '../../compounds/Search bars/Treesearch';




export default function Videos() {

    return(<>
    <Navbar />
    <Landingpage />
    <div className={styles.main}>
        <div className={styles.container}>
            <div className={styles.section}>
                <span className={styles.sectionSubtitle}>
                    'روایت‌ها و خاطرات'
                </span>
                <h1 className={styles.sectionTitle}>
                    'داستان‌ها'
                </h1>
                </div>
            <p className={styles.para}>
اینجا قراره داستان‌هایی از سید رو بشنوید؛ داستان‌هایی که توی شصت‌وچهار سال زندگی‌اش جریان داره و تا حالا جایی نخوندید و نشنیدید. تو این مسیر، زندگی جهادی‌اش رو از نزدیک لمس می‌کنید از همون روزای اول که مقاومت تازه شکل گرفته بود، تا وقتی که به یه قدرت منطقه‌ای تبدیل شد و حتی از اونم فراتر رفت.
            </p>
            <Button />
        </div>
    </div>

    <div className={styles.container} >
        <div className={styles.bodyContent}>
            <SearchSidebar />

            <StoriesBrowser />
        </div>
    </div>
    <Footer />
    </>);
}